import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import { WorkRow } from "../components/work/WorkRow";
import { mixByCategory, buildRows } from "../lib/workLayout";
import { WORK } from "../mock";
import { Seo } from "../components/Seo";

const rows = buildRows(mixByCategory(WORK));

export default function Work() {
  return (
    <div className="mp-paper min-h-screen flex flex-col" data-testid="work-page">
      <Seo page="work" />
      <Nav theme="light" />
      <main className="flex-1 w-full">
        <div className="max-w-[1600px] w-full mx-auto px-6 md:px-10 pt-10 md:pt-16">
          <h1 className="font-display font-light text-[34px] md:text-[42px] leading-[0.95] tracking-tight mp-fade">Work</h1>
          <p className="max-w-xl mt-5 text-[#5f5a50] text-[15px] md:text-[16px] leading-relaxed font-light mp-fade" style={{ animationDelay: "0.1s" }}>
            A selection of completed architecture and interior work — workplace, hospitality, and residential — across the U.S. and the UAE.
          </p>
        </div>

        <div className="max-w-[1600px] w-full mx-auto px-6 md:px-10 pt-10 md:pt-14 pb-28 space-y-4 md:space-y-6" data-testid="work-gallery">
          {rows.map((row) => (
            <WorkRow key={row.imgs[0]} row={row} />
          ))}

          <div className="mt-20 flex flex-col md:flex-row md:items-center justify-between gap-6 border-t border-[rgba(35,33,28,0.14)] pt-14">
            <h2 className="font-display text-[30px] md:text-[46px] leading-none tracking-tight">It starts here.</h2>
            <Link
              to="/inquiries"
              data-testid="work-inquiry-link"
              className="inline-flex items-center gap-2 bg-[#23211c] text-[#f2efe7] px-8 py-4 font-label text-[11px] hover:bg-[#3d3a33] transition-colors w-max"
            >
              Start an Inquiry <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.5} />
            </Link>
          </div>
        </div>
      </main>
      <Footer theme="light" />
    </div>
  );
}
